import useChatNotificationSound from "../components/notifications/useChatNotificationSound";
import { firestore } from "../init/firebase";
import { canSeeChat } from "../pages/Chat/utils";
import useInitChat from "../pages/Chat/utils/useInitChat";
import useCourtReservationsNotifications from "../pages/CourtsReservations/utils/useCourtReservationsNotifications";
import useOrdersNotifications from "../pages/Orders/utils/useOrdersNotifications";
import useRequestNotifications from "../pages/VisitsRequests/utils/useRequestsNotifications";
import { GenericObject } from "../types/generic.types";
import { AppResource } from "../types/resource.types";
import { UserRole } from "../types/user.types";
import useCurrentUser from "./useCurrentUser";
import useGetEnums from "./useGetEnums";
import useHideReloadIcon from "./useHideReloadIcon";
import useKickUserOff from "./useKickUserOff";
import { useCheckAgentType } from "./useCheckAgentType";
import useCoachReservationsNotifications from "../pages/Coaches/Reservations/utils/useCoachReservationsNotifications";
import useAcademyNotificationList from "../pages/Academies/AcademyNotifications/utils";
import useSportClubReviewsNotifications from "../pages/SportsClubsReviews/utils/useSportClubReviewsNotifications";
import useAcademyReviewsNotifications from "../pages/Academies/Reviews/utils/useAcademyReviewsNotifications";
import useCoachReviewsNotifications from "../pages/Coaches/Reviews/utils/useCoachReviewsNotifications";
import useGetSettings from "./useGetSettings";
import useEntertainmentReviewsNotifications from "../pages/EntertainmentsVendors/Reviews/utils/useEntertainmentReviewsNotifications";
import useGymNotificationList from "../pages/Gym/GymNotifications/utils";
import useGymReviewsNotifications from "../pages/Gym/Reviews/utils/useGymReviewsNotifications";
import useEntertainmentNotificationList from "../pages/EntertainmentsVendors/EntertainmentNotifications/utils";
import useSportClubNotificationList from "../pages/SportsClubs/SportsClubsNotifications/utils";
import useCoachNotificationList from "../pages/Coaches/CoachesNotifications/utils";
import useBrandNotificationList from "../pages/Brands/BrandsNotifications/utils";

const usePrepareApp = () => {
  const { user } = useCurrentUser();

  useGetEnums();
  useGetSettings();
  useInitChat();
  useHideReloadIcon();

  useKickUserOff(
    firestore.collection(AppResource.sportsClubs).doc(user.id),
    (data: GenericObject) => data.disabled,
    user.role === UserRole.sportClub
  );
  useKickUserOff(
    firestore.collection(AppResource.brands).doc(user.id),
    (data: GenericObject) => data.disabled,
    user.role === UserRole.store
  );
  useKickUserOff(
    firestore.collection(AppResource.agents).doc(user.id),
    (data: GenericObject) => data.disabled,
    user.role === UserRole.agent
  );

  const agentType = useCheckAgentType();

  /**
   * notification list entry point
   * */
  useGymNotificationList(user.role === UserRole.gym);
  useAcademyNotificationList(user.role === UserRole.academy);
  useSportClubNotificationList(user.role === UserRole.sportClub);
  useEntertainmentNotificationList(user.role === UserRole.entertainment);
  useCoachNotificationList(user.role === UserRole.coach);
  useBrandNotificationList(user.role === UserRole.store);

  useChatNotificationSound(canSeeChat(user.role, agentType));
  useCourtReservationsNotifications(agentType);

  useSportClubReviewsNotifications(agentType);
  useGymReviewsNotifications(agentType);
  useCoachReviewsNotifications(agentType);
  useAcademyReviewsNotifications(agentType);
  useEntertainmentReviewsNotifications(agentType);

  useOrdersNotifications(agentType);
  useRequestNotifications(agentType);
  useCoachReservationsNotifications(agentType);
};

export default usePrepareApp;
